import { faDownload } from "@jewlr/pro-regular-svg-icons/faDownload"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Image,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

const Container = styled(Flex).attrs((props) => ({
  alignItems: { _: "center", tablet: "flex-end" },
  contain: true,
  flexDirection: { _: "column", tablet: "row" },
  mb: { _: 4, tablet: 5 },
  mt: { _: 2, tablet: 0 },
  textAlign: { _: "center", tablet: "left" },
  ...props,
}))`
  gap: 32px;
  padding: 0;
`

const DownloadInvoice = styled(Button).attrs({
  forwardedAs: "a",
  outline: "primary",
})`
  border-radius: 3px;
  height: 36px;
  padding: 14px;
  font-weight: 700;
  width: 216px;
  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`

const Menu = ({ invoiceLink }) => {
  return (
    <Container>
      <Box width="100%">
        <Box as={Link} data-lc="header" display="block" to="/">
          <Image
            alt={sl.config.site_title}
            height="36"
            lazyload={false}
            src={require("images/logo/customize-your-jewelry-logo.svg")}
            width="141"
          />
        </Box>
      </Box>
      <Box>
        <DownloadInvoice
          data-lc="download-PDF-invoice"
          href={invoiceLink}
          rel="noopener noreferrer"
          startIcon={
            <FontAwesomeIcon
              fontSize="12px"
              icon={faDownload}
              style={{ verticalAlign: "baseline" }}
            />
          }
          target="_blank"
        >
          Download PDF Invoice
        </DownloadInvoice>
      </Box>
    </Container>
  )
}

Menu.propTypes = {
  invoiceLink: PropTypes.string,
}

export default Menu
